import type { RouteRecordRaw } from 'vue-router';

// Settings routes belong to their feature module, not to a shared settings
// module — the same ownership `/settings/labels` has in the labels module.
export const savedViewsRoute: RouteRecordRaw = {
  path: '/settings/views',
  name: 'SavedViews',
  component: () => import('./pages/SavedViewsPage.vue'),
  meta: {
    title: 'Views',
    layout: 'main',
    // Read-gated, not manage-gated: every user owns views of their own here,
    // and the row actions are gated individually on the server's `canEdit`.
    authorize: ({ isGranted }) => isGranted('dt:core:saved-views:list'),
  },
};
